module.exports = __webpack_public_path__ + "img/d200910-2.4487c8e4.jpg";